module.exports = __webpack_public_path__ + "img/email-marketing.d30f2360.svg";